import { render, staticRenderFns } from "./assessment-auth.vue?vue&type=template&id=6ac977ce&scoped=true"
import script from "./assessment-auth.vue?vue&type=script&lang=js"
export * from "./assessment-auth.vue?vue&type=script&lang=js"
import style0 from "./assessment-auth.vue?vue&type=style&index=0&id=6ac977ce&prod&lang=css"
import style1 from "./assessment-auth.vue?vue&type=style&index=1&id=6ac977ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac977ce",
  null
  
)

export default component.exports